import { ResponseTypes } from "../../services/APIEarlyWarningService";

const BASE_URL = process.env.REACT_APP_BASE_URL

export const getToken = (): string => {
    const token = localStorage.getItem("access_token");
    if (!token) {
        throw new Error("Missing access token");
    }
    return token
}

export type APIRequestCoordinate = {
    lat: number;
    lon: number;
}

export type APIRequestWorkflowInfo = {
    warningId: string;
    username: string;
    hazardType: string;
    warningType: string;
    departments: string;
    workflowType: string;
    triggerType: string;
    localizationType: string;
    areas: APIRequestCoordinate[][];
    localizationAreas: string[];
    minDepth: number;
    maxDepth: number;
    minMagnitude: number;
    maxMagnitude: number;
    msgEn: string;
    msgDv: string;
    msgBn: string;
    effectiveHours: number;
    severity: string;
} 

export const APIAddWorkflowInfos = async (request: APIRequestWorkflowInfo): Promise<{ status: boolean; message: string }> => {
    const url = `${BASE_URL}/workflow_engine/api/v1/createwarning`
    const header = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${getToken()}`
        },
        body: JSON.stringify(request)
    }
  
    try 
    {
        const response = await fetch(url, header)
        const responseData = await response.json()
    
        if (!response.ok) 
        {
            // API returned error
            return { status: false, message: responseData.message || "Request failed" }
        }
    
        return { status: true, message: "Template added successfully" }
    } 
    catch (error: any) 
    {
      return { status: false, message: error.message || "Network error" };
    }
}

// Get all information
export type APIResponseGetAllWorkflowInfo = {
    warningId: string;
    username: string;
    hazardType: string;
    warningType: string;
    departments: string;
    workflowType: string;
    triggerType: string;
    localizationType: string;
    areas: string;
    localizationAreas: string[];
    minDepth: number;
    maxDepth: number;
    minMagnitude: number;
    maxMagnitude: number;
    msgEn: string;
    msgDv: string;
    msgBn: string;
    effectiveHours: number;
    severity: string;
} 

export const APIGetAllWorkflowInfos = async (): Promise<{ status: boolean; data: APIResponseGetAllWorkflowInfo[], message: string }> => {
    const url = `${BASE_URL}/workflow_engine/api/v1/getallinformation`
    const header = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${getToken()}`
        }
    }
  
    try 
    {
        const response = await fetch(url, header)
        const responseData = await response.json() as ResponseTypes
    
        if (!response.ok) 
        {
            // API returned error
            return { status: false, data: [], message: responseData.message || "Request failed" }
        }
    
        return { status: true, data: responseData.data as APIResponseGetAllWorkflowInfo[], message: "Template added successfully" }
    } 
    catch (error: any) 
    {
      return { status: false, data: [], message: error.message || "Network error" };
    }
}